export default __webpack_public_path__ + "static/media/no_data.eb57724a.png";